import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('MainTab',{staticClass:"submenu-category-title",attrs:{"data-test-id":"bottom-navigation-route-lapro-help","href":_vm.link}},[_c(VIcon,{staticClass:"submenu-list-icon",attrs:{"color":"text"}},[_vm._v("$vuetify.icons.question")]),_vm._v(_vm._s(_vm.l.t('app.help', 'Help'))+"\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }